import { useAction } from '@src/redux/hooks/useAction';
import { useAsync } from '@src/redux/hooks/useAsync';
import { useSelect } from '@src/redux/hooks/useSelect';

import {
  DESIGNATE_PAA,
  SET_PHONE_NUMBER,
  RESET_STATE,
  SET_JOB_FUNCTIONS,
  SET_API_LIST,
  SET_SELF_ATTESTATION_DONE,
  SUBMIT_TIN_REQUEST,
  SET_API_USE_TEXT,
} from './constants';

import {
  designatePAA,
  setPhoneNumber,
  resetState,
  setJobFunctions,
  setApiList,
  setSelfAttestationDone,
  submitTINRequest,
  setApiUseText,
  setSelectedApiCodes,
} from './actions';

const designatedPAASelector = (state) => {
  return state.primaryAdmin;
};

export const usePAARegistration = {
  state: () => {
    return useSelect(designatedPAASelector);
  },
  actions: () => {
    return {
      designatePAA: useAction(designatePAA, {
        saga: useAsync(DESIGNATE_PAA),
      }),
      setJobFunctions: useAction(setJobFunctions, {
        saga: useAsync(SET_JOB_FUNCTIONS),
      }),
      setApiList: useAction(setApiList, {
        saga: useAsync(SET_API_LIST),
      }),
      setApiUseText: useAction(setApiUseText, {
        saga: useAsync(SET_API_USE_TEXT),
      }),
      setSelectedApiCodes: useAction(setSelectedApiCodes),
      setPhoneNumber: useAction(setPhoneNumber, {
        saga: useAsync(SET_PHONE_NUMBER),
      }),
      setSelfAttestationDone: useAction(setSelfAttestationDone, {
        saga: useAsync(SET_SELF_ATTESTATION_DONE),
      }),
      resetState: useAction(resetState, {
        saga: useAsync(RESET_STATE),
      }),
      submitTINRequest: useAction(submitTINRequest, {
        saga: useAsync(SUBMIT_TIN_REQUEST),
      }),
    };
  },
};
